/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceTypeEnum } from './NotificationPreferenceTypeEnum';
import {
    NotificationPreferenceTypeEnumFromJSON,
    NotificationPreferenceTypeEnumFromJSONTyped,
    NotificationPreferenceTypeEnumToJSON,
    NotificationPreferenceTypeEnumToJSONTyped,
} from './NotificationPreferenceTypeEnum';

/**
 * Request to update a notification preference
 * @export
 * @interface UpdateNotificationPreferenceRequest
 */
export interface UpdateNotificationPreferenceRequest {
    /**
     * 
     * @type {NotificationPreferenceTypeEnum}
     * @memberof UpdateNotificationPreferenceRequest
     */
    type: NotificationPreferenceTypeEnum;
    /**
     * Value of the notification preference
     * @type {string}
     * @memberof UpdateNotificationPreferenceRequest
     */
    value: string;
    /**
     * If the notification is active or not
     * @type {boolean}
     * @memberof UpdateNotificationPreferenceRequest
     */
    active: boolean;
}



/**
 * Check if a given object implements the UpdateNotificationPreferenceRequest interface.
 */
export function instanceOfUpdateNotificationPreferenceRequest(value: object): value is UpdateNotificationPreferenceRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function UpdateNotificationPreferenceRequestFromJSON(json: any): UpdateNotificationPreferenceRequest {
    return UpdateNotificationPreferenceRequestFromJSONTyped(json, false);
}

export function UpdateNotificationPreferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNotificationPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': NotificationPreferenceTypeEnumFromJSON(json['type']),
        'value': json['value'],
        'active': json['active'],
    };
}

export function UpdateNotificationPreferenceRequestToJSON(json: any): UpdateNotificationPreferenceRequest {
    return UpdateNotificationPreferenceRequestToJSONTyped(json, false);
}

export function UpdateNotificationPreferenceRequestToJSONTyped(value?: UpdateNotificationPreferenceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': NotificationPreferenceTypeEnumToJSON(value['type']),
        'value': value['value'],
        'active': value['active'],
    };
}

